export default __webpack_public_path__ + "static/media/roadmap-m-1.a1b38692.png";